import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router/composables';

import { Heading } from '@warrenbrasil/nebraska-web';
import { CardCounter } from '@/modules/common/components/cards/CardCounter';

import {
  IHomeButtonsV2,
  getButtonsV2,
  EButtonTypeV2
} from '@/modules/home/services/consolidation';

interface Emits {
  (event: 'open-register-panel'): void;
  (event: 'open-orders-panel', type: string): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeActivities',
  emits: ["open-register-panel", "open-orders-panel"],
  setup(__props, { emit }: { emit: ({
  (event: 'open-register-panel'): void;
  (event: 'open-orders-panel', type: string): void;
}), expose: any, slots: any, attrs: any }) {

const router = useRouter();



const isLoading = ref(true);
const homeButtons = ref<IHomeButtonsV2 | void>();

async function fetchButtons() {
  try {
    isLoading.value = true;

    homeButtons.value = await getButtonsV2();
  } finally {
    isLoading.value = false;
  }
}

function handleClick(type: EButtonTypeV2) {
  switch (type) {
    case EButtonTypeV2.IN_PORTABILITY:
      window.location.assign('/products/#/portability');
      break;
    case EButtonTypeV2.OUT_PORTABILITY:
      router.push({ name: 'portabilityRequests' });
      break;
    case EButtonTypeV2.APPROVALS:
      router.push({ name: 'investmentSuggestions' });
      break;
    case EButtonTypeV2.REGISTER:
      emit('open-register-panel');
      break;
    case EButtonTypeV2.INVESTMENT:
      emit('open-orders-panel', type);
      break;
    case EButtonTypeV2.REDEMPTION:
      emit('open-orders-panel', type);
      break;
    default:
      break;
  }
}

onMounted(fetchButtons);

return { __sfc: true,router, emit, isLoading, homeButtons, fetchButtons, handleClick, Heading, CardCounter }
}

})